module.exports = __webpack_public_path__ + "img/40_38_061_330.69561002.jpg";